import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../../components/common/DeleteModal";

import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../../components/elements/LimitSelect";
import { useEffect, useRef, useState } from "react";
import Search from "../../../../components/form/Search";
import Table from "../../../../components/elements/table/Table";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Button from "../../../../components/form/Button";
import { organizationDelete, organizationList } from "../../../../services/organizationService";
import ManageOrganizationDrawer from "../../../../components/sections/admin/Organization/Drawer/ManageOrganizationDrawer";
import dayjs from "dayjs";
import ActionBar from "../../../../components/elements/ActionBar";
import { lngDetect } from "../../../../helpers/lngDetect";
import Switch from "../../../../components/form/Switch";
import Badge from "../../../../components/elements/Badge";
import { categoryDelete, categoryList } from "../../../../services/categoryService";
import ManageCategoryDrawer from "../../../../components/sections/admin/Category/Drawer/ManageCategoryDrawer";
import { ticketList, ticketStatusChange } from "../../../../services/ticketService";
import ManageTicketDrawer from "../../../../components/sections/admin/Ticket/Drawer/ManageTicketDrawer";
import PopoverDropdown from "../../../../components/elements/PopoverDropdown";
import Select from "../../../../components/form/select/Select";
import CustomDropdown from "../../../../components/form/CustomDropdown";

const statusList = [
  { name: "pending", value: "pending", type: "checkbox" },
  { name: "active", value: "active", type: "checkbox" },
  { name: "invited", value: "invited", type: "checkbox" },
  { name: "deactivated", value: "deactivated", type: "checkbox" },
  { name: "deleted", value: "deleted", type: "checkbox" },
  { name: "inactive", value: "inactive", type: "checkbox" },
];

const Ticket = () => {
  setTitle("Stackora Admin | Ticket");
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const [type, setType] = useState("ticket");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["ticket", filters, search, type],
    queryFn: async () => {
      const res = await ticketList({
        ...filters,
        ...(search && { keyword: search }),
        type,
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  useEffect(() => {
    console.log(type);
  }, [type]);

  //   organization status change handler =================>
  const { mutate: statusChangeHandler } = useMutation({
    mutationFn: async ({ id, isActive }) => {
      queryClient.setQueryData(["ticket", filters, search], (state) => {
        if (state) {
          let stateData = JSON.parse(JSON.stringify(state?.data));
          stateData = (stateData || []).map((elm) =>
            elm?._id === id
              ? {
                  ...elm,
                  status: elm?.status === "active" ? "inActive" : "active",
                }
              : elm
          );
          return { ...state, data: stateData };
        }
      });
      const res = await ticketStatusChange({
        ids: id,
        status: isActive,
      });
      return { res, payload: { id, isActive } };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status !== 200) {
        queryClient.setQueryData(["ticket", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = (stateData || []).map((elm) =>
              elm?._id === payload?.id
                ? {
                    ...elm,
                    status: elm?.status === "active" ? "inActive" : "active",
                  }
                : elm
            );
            return { ...state, data: stateData };
          }
        });
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const tableHeadData = [
    {
      _id: 1,
      name: "Name",
      align: "left",
    },
    {
      _id: 2,
      name: "Amount",
      align: "left",
    },
    {
      _id: 9,
      name: "Event",
      align: "left",
    },
    {
      _id: 3,
      name: "Status",
      align: "left",
    },
    {
      _id: 3,
      name: "Created",
      align: "left",
    },
    {
      _id: 8,
      name: "Action",
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: lngDetect(item?.name) || "-",
          image: item?.image?.url,
          isTooltip: false,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (item?.eventData?.currency?.symbol ? "(" + item?.eventData?.currency?.symbol + ")" : "") + " " + (item?.price || "-"),
        },
                {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.eventData?.title?.en || "-",
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: dayjs(item?.createdAt).format("MMM DD, YYYY") || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: (
            <div>
              <PopoverDropdown
                buttonClass={"p-0 bg-transparent"}
                buttonLabel={<Badge label={item?.status} className={"capitalize"} type={item?.status === "active" ? "success" : "danger"} />}
              >
                <ul>
                  {statusList?.map((status, i) => (
                    <li key={i?.toString()} className="hover:text-white px-2 py-2 hover:bg-gray-700/40 rounded-md">
                      <button
                        className="flex items-center justify-start w-full h-full"
                        type="button"
                        onClick={() => {
                          statusChangeHandler({
                            status: status?.value,
                            id: item?._id,
                          });
                        }}
                      >
                        {status?.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </PopoverDropdown>
            </div>
          ),
        },
        {
          _id: 9,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 9.1,
              name: "Details",
              icon: "fa-regular fa-circle-info",
              onClick: () => {
                setModalOpen({ isOpen: true, data: item });
              },
              standout: false,
            },
            // {
            //   _id: 9.2,
            //   name: "Delete",
            //   icon: "fa-regular fa-trash-can",
            //   standout: true,
            //   onClick: () => {
            //     setDeleteModal({
            //       isOpen: true,
            //       data: item,
            //     });
            //   },
            // },
          ],
        },
      ],
    };
  });

  // add or edit page =================>
  function pageManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          queryClient.setQueryData(["ticket", filters, search], (state) => {
            if (state) {
              let stateData = JSON.parse(JSON.stringify(state?.data));
              stateData = [res?.data, ...stateData];
              return { ...state, data: stateData };
            }
          });
          if (data?.metadata?.totalDocs > filters?.limit) {
            queryClient.invalidateQueries(["ticket", filters, search]);
          }
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        queryClient.setQueryData(["ticket", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.map((item) => (item?._id === res?.data?._id ? { ...item, ...res?.data } : item));
            return { ...state, data: stateData };
          }
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["ticket", filters, search]);
        }
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   organization delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await categoryDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        queryClient.setQueryData(["ticket", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.filter((item) => !payload?.includes(item?._id));

            return { ...state, data: stateData };
          }
        });

        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["ticket", filters, search]);
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const options = [
    {
      id: "userDelete",
      icon: "fa-regular fa-trash-can",
      tooltip: "User Delete",
    },
  ];

  function actionHandler(val) {
    switch (val) {
      case "userDelete":
        setDeleteModal({
          isOpen: true,
          data: { _id: selectedItems },
        });
        break;

      default:
        break;
    }
  }

  return (
    <div className="w-full flex flex-col pb-10 bg-white rounded-md">
      <div className="space-y-8 py-8 px-5">
        <div className="flex justify-between items-center border-b border-gray-300">
          <div className="flex flex-col gap-2 w-full">
            <div className="font-bold text-lg xl:text-2xl uppercase tracking-tighter font-Montserrat">Ticket Management</div>
            <div className="text-sm xl:text-base h-10">
              Easily handle all ticket actions: update ticket info, amount, status, and add new ticket data.
            </div>
          </div>
          {/* <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-primary/10 hover:!border-primary/10"
              }
              variant="secondary"
              buttonLabel={"Create New"}
              buttonLabelClasses={
                "font-medium !text-sm uppercase whitespace-nowrap"
              }
              buttonHasLink
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div> */}
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-36">
              <LimitSelect
                value={filters?.limit}
                allValue={data?.metadata?.totalDocs}
                onChange={(val) => handleFilterChange("limit", val, setFilters)}
              />
            </div>
            <div className="w-72">
              <Search
                placeholder={"Search here"}
                search={(val) => {
                  setKeyword(val);
                  handleFilterChange("page", 1, setFilters);
                }}
              />
            </div>
            <div className="w-40">
            <CustomDropdown
              options={[
                {
                  label: "Tickets",
                  value: "ticket",
                  icon: "fa-light fa-ticket",
                  sub: [
                    { label: "Booked", value: "booked" },
                    { label: "Un Booked", value: "un-booked" },
                  ],
                },
                { label: "Add-ons", value: "addons", icon: "fa-light fa-plus" },
              ]}
              value={type}
              onChange={setType}
            />
            </div>

            {selectedItems?.length > 0 && (
              <div className="flex items-center gap-2">
                <ActionBar options={options} onChange={actionHandler} />
                <span className="flex items-center rounded-full bg-secondary text-surface-01 text-xs px-3 py-1 gap-2">
                  {selectedItems?.length} Selected
                  <button onClick={() => setSelectedItems([])} type="button" className="cursor-pointer">
                    <i className="fa-fw fa-light fa-xmark"></i>
                  </button>
                </span>
              </div>
            )}
          </div>
          {/* <div className="flex items-center gap-3">
            <div className="relative">
              <Select
                selectedValue={"Buyer"}
                dropdownData={[{ name: "Buyer", value: "Buyer" }]}
                onChange={(val) => {
                  console.log({ val });
                  handleChange({ target: { name: "parent", value: val } });
                }}
                onScroll={(e) => {
                  loadData(e, categories, setCategoryilters);
                }}
              />
            </div>
            <div className="relative">
              <Select
                selectedValue={"Past 3 month"}
                dropdownData={[{ name: "Past 3 month", value: "Past 3 month" }]}
                // onChange={(val) => {
                //   console.log({ val });
                //   handleChange({ target: { name: "parent", value: val } });
                // }}
                // onScroll={(e) => {
                //   loadData(e, categories, setCategoryilters);
                // }}
              />
            </div>
          </div> */}
        </div>
        <Table
          tableHeadData={tableHeadData}
          tableData={tableData}
          isLoder={isLoading}
          pageCount={data?.metadata?.totalPages}
          currentPage={filters?.page}
          onPageChange={(val) => {
            handleFilterChange("page", val, setFilters);
            setSelectedItems([]);
          }}
          handleOrdering={(val) => {
            console.log(val);
          }}
          isFetching={isFetching}
          isOrderingDisabled={true}
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          tableActionDropdownContainer={"!w-48"}
          // selectable
        />
      </div>
      <ManageTicketDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={pageManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Ticket;
